import {
  CreateInventorySummary,
  InventoryListSummary,
  InventorySummary,
  UpdateInventorySummary,
} from "../client/types.gen";
import { BaseEndpoint } from "./BaseEndpoint";
import { Page } from "./domain";
import { WithGet } from "./mixins/WithGet";
import { WithUpdate } from "./mixins/WithUpdate";
import { getManyInventoryQuery } from "./query/getManyInventoryQuery";

export class Endpoint extends BaseEndpoint("inventories") {
  getPage(query?: getManyInventoryQuery): Promise<Page<InventoryListSummary>> {
    return this.request("", { query });
  }

  create(inventory: CreateInventorySummary): Promise<InventorySummary> {
    return this.request("", {
      method: "POST",
      body: inventory,
    });
  }
}
const withGetOne = WithGet<typeof Endpoint, InventorySummary>(Endpoint);

export const InventoryEndpoint = WithUpdate<typeof withGetOne, InventorySummary, UpdateInventorySummary>(withGetOne);
